export default __webpack_public_path__ + "f3f27f03974baf2ae7b64a4acb5d8892.png";